<template>
	<div class="plan-pro">
		<p class="plan-pro__title">{{ PRO_PLAN_TITLE }}</p>
		<p v-if="periodEndLabel" class="plan-pro__period">{{ PRO_PERIOD_LABEL }}: {{ periodEndLabel }}</p>

		<div class="plan-pro__limits">
			<limit-progress-bar v-for="row in rows" :key="row.key" :title="row.title" :used="row.used" :limit="row.limit" />
		</div>
		<router-link to="/profile/subscription" class="plan-pro__link">{{ SUBSCRIPTION_LINK }}</router-link>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import LimitProgressBar from '@/components/profile/LimitProgressBar.vue'
import { useUsageStore, type UsageResource } from '@/stores/usage'
import { formatDayMonth } from '@/utils/formatDate'
import { PRO_PERIOD_LABEL, PRO_PLAN_TITLE, SUBSCRIPTION_LINK } from '@/constants/pro'

const RESOURCE_TITLES: Record<UsageResource, string> = {
	text: 'Текстовые запросы',
	image: 'Изображения',
	song: 'Песни'
}

const usageStore = useUsageStore()

const periodEndLabel = computed(() => formatDayMonth(usageStore.periodEnd))

const rows = computed(() => {
	const limits = usageStore.limits
	return (Object.keys(RESOURCE_TITLES) as UsageResource[]).map((key) => ({
		key,
		title: RESOURCE_TITLES[key],
		used: limits?.[key].used ?? 0,
		limit: limits?.[key].limit ?? 0
	}))
})
</script>

<style lang="scss" scoped>
.plan-pro {
	@include flex-column-center;
	width: 100%;
	&__title {
		font: var(--font-title);
		color: var(--text-primary);
		text-align: center;
		margin-bottom: 12px;
	}
	&__period {
		font: var(--font-body-small);
		color: var(--text-secondary);
		text-align: center;
		margin-bottom: 32px;
	}
	&__limits {
		display: flex;
		flex-direction: column;
		gap: 16px;
		width: 100%;
		margin-bottom: 32px;
	}
	&__link {
		font: var(--font-caption);
		color: var(--text-secondary);
		text-align: center;
		text-decoration-line: underline;
		text-decoration-style: solid;
		text-decoration-skip-ink: auto;
		text-decoration-thickness: 6%;
		text-underline-offset: 22.5%;
		text-underline-position: from-font;
		transition: $transition-color;
		&:hover {
			color: var(--text-secondary-hover);
		}
		&:active {
			color: var(--text-secondary-hover);
		}
	}
}
</style>
